import React, {ComponentType, ReactElement} from 'react';
import {EducationPhase} from '../types/enums';

export interface WithEducationPhaseProps {
  educationPhase: EducationPhase;
}

export function withEducationPhase<PassedPropsAndEducationPhase extends WithEducationPhaseProps>(
  Component: ComponentType<PassedPropsAndEducationPhase>,
  educationPhase: EducationPhase
) {
  return function WithEducationPhase(
    props: Omit<PassedPropsAndEducationPhase, 'educationPhase'>
  ): ReactElement | null {
    return (
      <Component {...(props as PassedPropsAndEducationPhase)} educationPhase={educationPhase} />
    );
  };
}
